export const InputPatterns = {
    URL: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
};
